import React from 'react';
import { dispatch } from '../bridge/events/dispatch';
import { DESTROY_CONTAINER } from '../bridge/events/types';
import { renderManageTreatmentPackages } from '../bridge/methods';
import { captureError } from './captureError';

const MANAGE_TREATMENTS_CONTAINER_ID = 'MANAGE_TREATMENTS_CONTAINER_ID';

const ManageTreatmentsContainer: React.FC = () => {
    React.useEffect(() => {
        const configs = {
            containerId: MANAGE_TREATMENTS_CONTAINER_ID,
            queryParams: '',
            routeParams: {},
        };
        if (!window.RENDER_CONFIGS) {
            window.RENDER_CONFIGS = [];
        }

        window.RENDER_CONFIGS.push(configs);

        try {
            renderManageTreatmentPackages(configs);
        } catch (e) {
            console.log(e);
            captureError(e as Error);
        }

        return () => {
            dispatch({ type: DESTROY_CONTAINER, containerId: MANAGE_TREATMENTS_CONTAINER_ID });
            window.RENDER_CONFIGS = window.RENDER_CONFIGS?.filter(
                (renderConfig) => renderConfig.containerId !== MANAGE_TREATMENTS_CONTAINER_ID,
            );
        };
    }, []);

    return (
        <div
            id={MANAGE_TREATMENTS_CONTAINER_ID}
            className="flex justify-start overflow-auto flex-col col-span-10 items-start w-full h-full"
        />
    );
};

export default ManageTreatmentsContainer;
